// extracted by mini-css-extract-plugin
module.exports = {"profile":"IRP_profile__34WMH"};